import React from 'react';
import History from './History';
import SearchMenu, { FilterConsumer } from '../components/SearchMenu';
import { getAgenciesFullPermission } from 'reducers/PermissionsReducer';
import { Redirect } from 'react-router-dom';
function EventsSearch() {
  const canReadAgencies = getAgenciesFullPermission('cad', 'Events', 'Read');
  if (!canReadAgencies.length) return <Redirect to="/" />;
  return (
    <SearchMenu agencyList={canReadAgencies}>
      <FilterConsumer>{(AgencyFilter) => <History filter={AgencyFilter} />}</FilterConsumer>
    </SearchMenu>
  );
}

export default EventsSearch;
